const HUB = 'https://invoice-review.system-0f7.workers.dev';

export type ClassifiedType =
  | 'invoice'
  | 'bank_auto_debit'
  | 'bank_transfer_in'
  | 'petty_cash'
  | 'shitsucho_tatekae'
  | 'yakuin_tatekae'
  | 'honbu_cash_out'
  | 'honbu_cash_in'
  | 'nippou_zreceipt'
  | 'cover_image'
  | 'unknown';

export interface FileboxClassification {
  id: number;
  freee_receipt_id: number;
  receipt_description: string | null;
  receipt_mime_type: string | null;
  receipt_partner_name: string | null;
  receipt_issue_date: string | null;
  receipt_amount: number | null;
  classified_type: ClassifiedType;
  classification_confidence: 'high' | 'medium' | 'low' | null;
  reader_a_result: any;
  reader_b_result: any;
  reconcile_verdict: 'agree' | 'disagree' | 'agree_with_notes' | null;
  predicted_deal_json: any;
  predicted_section_reason: string | null;
  status: 'pending' | 'classification_approved' | 'deal_proposed' | 'approved' | 'modified' | 'rejected' | 'processed';
  source_type?: 'arica_email' | 'filebox' | 'manual' | null;
  source_ref?: string | null;
  source_pdf_url?: string | null;
  classification_approved_at?: string | null;
  classification_approved_by?: string | null;
  deal_proposed_at?: string | null;
  deal_approved_at?: string | null;
  deal_approved_by?: string | null;
  user_modification: any;
  rejection_reason: string | null;
  classified_at: string;
  approved_at: string | null;
  approved_by: string | null;
  processed_at: string | null;
  freee_deal_id: number | null;
  // v11 additions
  ref_number?: string | null;
  content_hash?: string | null;
  dedupe_key?: string | null;
  reader_c_result?: any;
  reconcile_judge_reason?: string | null;
  missing_evidence?: any;
  verification_stages?: any;
  routed_to_ref?: string | null;
  routed_at?: string | null;
  route_decision?: 'matched_existing_arica' | 'new_filebox_ref' | 'type_mismatch' | null;
  modify_scope?: 'full_reclassify' | 'deal_only' | 'none' | null;
  reclassify_required_at?: string | null;
}

export async function fetchFilebox(status = 'pending', type?: string): Promise<FileboxClassification[]> {
  const params = new URLSearchParams({ status, limit: '200' });
  if (type) params.set('type', type);
  const r = await fetch(`${HUB}/api/filebox?${params}`);
  if (!r.ok) throw new Error(`fetchFilebox failed: ${r.status}`);
  const body = await r.json();
  return body.items || [];
}

// STAGE 1: classification (証憑タイプ) approval — triggers deal proposal generation by Claude
export async function approveClassification(id: number): Promise<void> {
  const r = await fetch(`${HUB}/api/filebox/${id}/approve-classification`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ approved_by: 'web_app_user' }),
  });
  if (!r.ok) throw new Error(`approve-classification failed: ${r.status}`);
}

// STAGE 2: deal (仕訳) approval — triggers freee deal registration
export async function approveFilebox(id: number): Promise<void> {
  const r = await fetch(`${HUB}/api/filebox/${id}/approve`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ approved_by: 'web_app_user' }),
  });
  if (!r.ok) throw new Error(`approve failed: ${r.status}`);
}

export async function rejectFilebox(id: number, reason: string): Promise<void> {
  const r = await fetch(`${HUB}/api/filebox/${id}/reject`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ reason }),
  });
  if (!r.ok) throw new Error(`reject failed: ${r.status}`);
}

export async function modifyFilebox(
  id: number,
  payload: { classified_type?: ClassifiedType; predicted_deal_json?: any; user_modification?: any; reason?: string }
): Promise<void> {
  const r = await fetch(`${HUB}/api/filebox/${id}/modify`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!r.ok) throw new Error(`modify failed: ${r.status}`);
}

export async function fetchFileboxSummary(): Promise<{ classified_type: string; status: string; n: number }[]> {
  const r = await fetch(`${HUB}/api/filebox/summary`);
  const body = await r.json();
  return body.summary || [];
}

export const TYPE_LABELS: Record<ClassifiedType, string> = {
  invoice: '請求書 (25日払い)',
  bank_auto_debit: '口座引落 (光熱費等)',
  bank_transfer_in: '入金 (ALSOK/JCB等)',
  petty_cash: '小口現金',
  shitsucho_tatekae: '室長立替金',
  yakuin_tatekae: '役員立替金',
  honbu_cash_out: '本部現金 出金',
  honbu_cash_in: '本部現金 入金',
  nippou_zreceipt: 'スマレジ日報 Z',
  cover_image: '表紙画像',
  unknown: '判別不能',
};
